import Moment from 'moment';
import AsyncStorage from "@react-native-async-storage/async-storage";

export const setStore = async function(key, value) {
    try {
        await AsyncStorage.setItem(key, value)
    } catch (e) {
        // saving error
    }
}
export const getStore = async function(key) {
    try {
        const value = await AsyncStorage.getItem(key)
        if (value !== null) return value; else return null;
    } catch(e) {
        // error reading value
    }
}
export function AsyncDispatch(dispatch, type, payload) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: type,
            payload: payload
        });
        resolve()
    });
}
export function transferTaskToDate(dispatch, id, from, to) {
    getStore('@wtitl.' + from).then(rFrom => {
        let fromTasks = JSON.parse(rFrom);
        fromTasks[id] = {...fromTasks[id], ...{transfer: ((fromTasks[id].transfer ?? 0) + 1)}}
        getStore('@wtitl.' + to).then(rTo => {
            let toTasks = JSON.parse(rTo);
            toTasks = {...toTasks, ...{[id]: fromTasks[id]}}
            delete(fromTasks[id]);
            setStore('@wtitl.' + to, JSON.stringify(toTasks)).then(() => {
                dispatch({type: 'REMOVE_TASK', payload: {id:id, complete:false}});
                dispatch({type: 'SAVE_TASK', payload:[]});
            });
        });
    });

}
export function loadTasks(dispatch, period) {
    let dates = [];
    let tasks = {};
    let completed = 0;
    let total = 0;
    dispatch({type: 'RESET_TASK', payload: {tasks: {}, total: 0, completed: 0}});

    if (period) {
        dates.push(Moment(period.from, 'DD.MM.YYYY').format('DD.MM.YYYY'));
        let from = Moment(period.from, 'DD.MM.YYYY').startOf('day');
        let to = Moment(period.to, 'DD.MM.YYYY').startOf('day');
        while(from.add(1, 'days').diff(to) <= 0) {
            dates.push(from.clone().format('DD.MM.YYYY'));
        }
    } else {
        dates.push(Moment().format('DD.MM.YYYY'));
    }

    dates.map((prop, key) => {
        getStore('@wtitl.' + dates[key]).then(r => {
            if (r) {
                let dayTasks = JSON.parse(r);
                if (dayTasks && Object.keys(dayTasks).length > 0) {
                    Object.keys(dayTasks).map((prop, key) => {
                        if (dayTasks[prop].complete) completed++;
                    });
                }
                tasks = {...tasks, ...dayTasks};
                dispatch({type: 'LOAD_TASK', payload: {tasks: tasks, total: Object.keys(tasks).length, completed: completed}});
            }
        })
    })
}
export function loadSettings(dispatch) {
    getStore('@wtitl.settings').then(r => {
        if (r) {
            let settings = JSON.parse(r);
            dispatch({type: 'LOAD_SETTINGS', payload: {settings: settings}});
        }
    })
}
export function loadTheme(dispatch) {
    getStore('@wtitl.theme').then(r => {
        if (r) {
            dispatch({type: 'LOAD_THEME', payload: {theme: r}});
        }
    })
}
export function loadLang(dispatch) {
    getStore('@wtitl.lang').then(r => {
        if (r) {
            dispatch({type: 'LOAD_LANG', payload: {lang: r}});
        } else
            dispatch({type: 'LOAD_LANG', payload: {lang: 'en'}});
    })
}

export const changeText = (dispatch, id, text) => {
    AsyncDispatch(dispatch,"EDIT_TASK", {id:id, data: {text: text}}).then(() => {
        dispatch({type: 'SAVE_TASK', payload:[]});
    })
}
export const checkTask = (dispatch, id, complete) => {
    AsyncDispatch(dispatch,"COMPLETE_TASK", {id:id, complete: !complete}).then(() => {
        dispatch({type: 'SAVE_TASK', payload:[]});
    })
}